import { Box, styled } from "@mui/material";

export const Content = styled(Box)({
  width: "calc(100% - 40px)",
  maxWidth: "640px",
  minWidth: "330px",
  display: "flex",
  justifyContent: "center",
  borderBottom: "3px solid #F2720C",
});
